export const ERRORS = {
  a1: 'Ocorreu um erro ao buscar as estações.',
};

export const webSocketApiUrlsDictionary = {
  br_super_carga: {
    wsUrl: 'https://cs-brsupercarga.brocpp.app/ws',
    apiUrl: 'https://cs-brsupercarga.brocpp.app/api/v1/',
    gatewayUrl: 'https://mk-gw-prod.brocpp.app',
  },
  eletrograal: {
    wsUrl: 'https://cs.eletrograalocpp.com.br/ws/',
    apiUrl: 'https://cs.eletrograalocpp.com.br/api/v1/',
    gatewayUrl: 'https://mk-gw-prod.eletrograalocpp.com.br',
  },
  dcc_energy: {
    wsUrl: 'https://cs.dccenergy.app/ws/',
    apiUrl: 'https://cs.dccenergy.app/api/v1/',
    gatewayUrl: 'https://mk-gw-prod.dccenergy.app',
    monitoringUrl: '',
  },
  linkplusenergy: {
    wsUrl: 'https://cs.linkplusenergy.app/ws/',
    apiUrl: 'https://cs.linkplusenergy.app/api/v1/',
    gatewayUrl: 'https://mk-gw-prod.linkplusenergy.app',
  },
  energia_atual: {
    wsUrl: 'https://cs.energiaatual.app/ws/',
    apiUrl: 'https://cs.energiaatual.app/api/v1/',
    gatewayUrl: 'https://mk-gw-prod.energiaatual.app',
  },
  isofen: {
    wsUrl: 'https://cs.isofen.app/ws/',
    apiUrl: 'https://cs.isofen.app/api/v1/',
    gatewayUrl: 'https://mk-gw-prod.isofen.app',
  },
  terpel: {
    wsUrl: 'https://cs.terpel-co.app/ws/',
    apiUrl: 'https://cs.terpel-co.app/api/v1/',
    gatewayUrl: 'https://mk-gw-prod.terpel-co.app',
    monitoringUrl: 'https://monitoring-js-terpel.use-move.app',
  },
  intelbras: {
    wsUrl: 'https://cs.intelbras-cve-pro.com.br/ws/',
    apiUrl: 'https://cs.intelbras-cve-pro.com.br/api/v1/',
    gatewayUrl: 'https://mk-gw-prod.intelbras-cve-pro.com.br',
  },
  plugbra: {
    wsUrl: 'https://cs.plugbra.app/ws/',
    apiUrl: 'https://cs.plugbra.app/api/v1/',
    gatewayUrl: 'https://mk-gw-prod.plugbra.app',
  },
  eveletroposto: {
    wsUrl: 'https://cs.eveletroposto.app/ws/',
    apiUrl: 'https://cs.eveletroposto.app/api/v1/',
    gatewayUrl: 'https://mk-gw-prod.eveletroposto.app',
  },
  oncharge: {
    wsUrl: 'https://cs.oncharge.app/ws/',
    apiUrl: 'https://cs.oncharge.app/api/v1/',
    gatewayUrl: 'https://mk-gw-prod.oncharge.app',
  },
  celesc: {
    wsUrl: 'https://cs.celesc.app/ws/',
    apiUrl: 'https://cs.celesc.app/api/v1/',
    gatewayUrl: 'https://mk-gw-prod.celesc.app',
    monitoringUrl: 'https://monitoring-js-celesc.use-move.app',
    biUrl:
      'https://app.powerbi.com/view?r=eyJrIjoiYTYxODliMTMtMGFkNy00NzMxLTlmZjUtNThkMjEzMzkyMGFhIiwidCI6IjVhZWE2YjVhLTZmOGEtNDUyMy05OTNmLWFlN2E0NjA0YTI3YSJ9',
  },
  rinno: {
    wsUrl: 'https://cs.rinno.app/ws/',
    apiUrl: 'https://cs.rinno.app/api/v1/',
    gatewayUrl: 'https://mk-gw-prod.rinno.app',
  },
  mocelin: {
    wsUrl: 'https://cs.mocelin.app/ws/',
    apiUrl: 'https://cs.mocelin.app/api/v1/',
    gatewayUrl: 'https://mk-gw-prod.mocelin.app',
  },
  vapt: {
    wsUrl: 'https://cs.vaptenergy.app/ws/',
    apiUrl: 'https://cs.vaptenergy.app/api/v1/',
    gatewayUrl: 'https://mk-gw-prod.vaptenergy.app',
  },
  centry_energy: {
    wsUrl: 'https://cs.vaptenergy.app/ws/',
    apiUrl: 'https://cs.vaptenergy.app/api/v1/',
    gatewayUrl: 'https://mk-gw-prod.vaptenergy.app',
  },
  edenred: {
    wsUrl: 'https://cs-edenred.use-move.com/ws/',
    apiUrl: 'https://cs-edenred.use-move.com/api/v1/',
    gatewayUrl: 'https://mk-gw-edenred.use-move.com.br',
  },
  copel: {
    wsUrl: 'https://cs.copel.app/ws/',
    apiUrl: 'https://cs.copel.app/api/v1/',
    gatewayUrl: 'https://mk-gw-prod.copel.app',
  },
  canaa: {
    wsUrl: 'https://cs-canaa.use-move.com/ws/',
    apiUrl: 'https://cs-canaa.use-move.com/api/v1/',
    gatewayUrl: 'https://mk-gw-canaa.use-move.com.br',
  },
  energize_c: {
    wsUrl: 'https://cs-energizec.use-move.com.br/ws/',
    apiUrl: 'https://cs-energizec.use-move.com.br/api/v1/',
    gatewayUrl: 'https://mk-gw-prod.use-move.com',
  },
  ledax: {
    wsUrl: 'https://cs-ledax.use-move.com/ws/',
    apiUrl: 'https://cs-ledax.use-move.com/api/v1/',
    gatewayUrl: 'https://mk-gw-prod.use-move.com',
  },
  carregar: {
    wsUrl: 'https://cs-carregar.use-move.com/ws/',
    apiUrl: 'https://cs-carregar.use-move.com/api/v1/',
    gatewayUrl: 'https://mk-gw-prod.use-move.com',
  },
  poenergy: {
    wsUrl: 'https://cs-poenergy.use-move.com/ws/',
    apiUrl: 'https://cs-poenergy.use-move.com/api/v1/',
    gatewayUrl: 'https://mk-gw-group04.use-move.com.br',
  },
  nowcharge: {
    wsUrl: 'https://cs-nowcharge.use-move.com/ws/',
    apiUrl: 'https://cs-nowcharge.use-move.com/api/v1/',
    gatewayUrl: 'https://mk-gw-nowcharge.use-move.com',
  },
  planetacharger: {
    wsUrl: 'https://cs-planeta.use-move.com/ws/',
    apiUrl: 'https://cs-planeta.use-move.com/api/v1/',
    gatewayUrl: 'https://mk-gw-group04.use-move.com.br',
  },
  plugmove: {
    wsUrl: 'https://cs-plugmove.use-move.com/ws/',
    apiUrl: 'https://cs-plugmove.use-move.com/api/v1/',
    gatewayUrl: 'https://mk-gw-group04.use-move.com.br',
  },
  planetacharge: {
    wsUrl: 'https://cs-planetacharge.use-move.com/ws/',
    apiUrl: 'https://cs-planetacharge.use-move.com/api/v1/',
    gatewayUrl: 'https://mk-gw-planetacharge.use-move.com',
  },
  eletrix: {
    wsUrl: 'https://cs-eletrix.use-move.com.br/ws/',
    apiUrl: 'https://cs-eletrix.use-move.com.br/api/v1/',
    gatewayUrl: 'https://mk-gw-eletrix.use-move.app',
  },
  threel_amazon: {
    wsUrl: 'https://cs-3lamazon.use-move.com.br/ws/',
    apiUrl: 'https://cs-3lamazon.use-move.com.br/api/v1/',
    gatewayUrl: 'https://mk-gw-3lamazon.use-move.com.br',
  },
  redeteles: {
    wsUrl: 'https://cs-3lamazon.use-move.com.br/ws/',
    apiUrl: 'https://cs-3lamazon.use-move.com.br/api/v1/',
    gatewayUrl: 'https://mk-gw-3lamazon.use-move.com.br',
  },
  eletricarr: {
    wsUrl: 'https://cs-eletricarr.use-move.com.br/ws/',
    apiUrl: 'https://cs-eletricarr.use-move.com.br/api/v1/',
    gatewayUrl: 'https://mk-gw-eletricarr.use-move.com.br',
  },
  amazonpark: {
    wsUrl: 'https://cs-3lamazon.use-move.com.br/ws/',
    apiUrl: 'https://cs-3lamazon.use-move.com.br/api/v1/',
    gatewayUrl: 'https://mk-gw-3lamazon.use-move.com.br',
  },
  elesol: {
    wsUrl: 'https://cs-elesol.use-move.com.br/ws/',
    apiUrl: 'https://cs-elesol.use-move.com.br/api/v1/',
    gatewayUrl: 'https://mk-gw-elesol.use-move.com.br',
  },
  carregafacil: {
    wsUrl: 'https://cs-carregafacil.use-move.com.br/ws/',
    apiUrl: 'https://cs-carregafacil.use-move.com.br/api/v1/',
    gatewayUrl: 'https://mk-gw-carregafacil.use-move.com.br',
  },
  komeco: {
    wsUrl: 'https://cs-komeco.use-move.com.br/ws/',
    apiUrl: 'https://cs-komeco.use-move.com.br/api/v1/',
    gatewayUrl: 'https://mk-gw-komeco.use-move.com.br',
  },
  chargin: {
    wsUrl: 'https://cs-chargin.use-move.com.br/ws/',
    apiUrl: 'https://cs-chargin.use-move.com.br/api/v1/',
    gatewayUrl: 'https://mk-gw-chargin.use-move.com.br',
  },
  eletropostos_nordeste: {
    wsUrl: 'https://cs-eletropostosnordeste.use-move.com.br/ws/',
    apiUrl: 'https://cs-eletropostosnordeste.use-move.com.br/api/v1/',
    gatewayUrl: 'https://mk-gw-eletropostosnordeste.use-move.com.br',
  },
  ultra_tecnologia: {
    wsUrl: 'https://cs-ultratecnologia.use-move.com.br/ws/',
    apiUrl: 'https://cs-ultratecnologia.use-move.com.br/api/v1/',
    gatewayUrl: 'https://mk-gw-ultratecnologia.use-move.com.br',
  },
  simplaenergia: {
    wsUrl: 'https://cs-simplaenergia.use-move.com.br/ws/',
    apiUrl: 'https://cs-simplaenergia.use-move.com.br/api/v1/',
    gatewayUrl: 'https://mk-gw-simplaenergia.use-move.com.br',
  },
  joyenergy: {
    wsUrl: 'https://cs-joyenergy.use-move.com.br/ws/',
    apiUrl: 'https://cs-joyenergy.use-move.com.br/api/v1/',
    gatewayUrl: 'https://mk-gw-joyenergy.use-move.com.br',
  },
  mobilegreen: {
    wsUrl: 'https://cs-mobilegreen.use-move.com.br/ws/',
    apiUrl: 'https://cs-mobilegreen.use-move.com.br/api/v1/',
    gatewayUrl: 'https://mk-gw-mobilegreen.use-move.com.br',
  },
  ecofortte_eletropostos: {
    wsUrl: 'https://cs.oncharge.app/ws/',
    apiUrl: 'https://cs.oncharge.app/api/v1/',
    gatewayUrl: 'https://mk-gw-prod.oncharge.app',
  },
  neoenergia: {
    wsUrl: 'https://cs-neoenergia.use-move.com.br/ws/',
    apiUrl: 'https://cs-neoenergia.use-move.com.br/api/v1/',
    gatewayUrl: 'https://mk-gw-neoenergia.use-move.app',
  },
  poraquerecargas: {
    wsUrl: 'https://cs-poraque.use-move.com.br/ws/',
    apiUrl: 'https://cs-poraque.use-move.com.br/api/v1/',
    gatewayUrl: 'https://mk-gw-poraque.use-move.com.br',
  },
  smartcenter: {
    wsUrl: 'https://cs-smartcenter.use-move.app/ws/',
    apiUrl: 'https://cs-smartcenter.use-move.app/api/v1/',
    gatewayUrl: 'https://mk-gw-smartcenter.use-move.app',
  },
  condupay: {
    wsUrl: 'https://cs-condupay.use-move.app/ws/',
    apiUrl: 'https://cs-condupay.use-move.app/api/v1/',
    gatewayUrl: 'https://mk-gw-condupay.use-move.app',
  },
  g3infinitypower: {
    wsUrl: 'https://cs-g3infinitypower.use-move.com.br/ws/',
    apiUrl: 'https://cs-g3infinitypower.use-move.com.br/api/v1/',
    gatewayUrl: 'https://mk-gw-g3infinitypower.use-move.com.br',
  },
};

/**
 * Charge box IDs classified as P&D (Pesquisa & Desenvolvimento) for CELESC.
 *
 * Copied verbatim from the source HTML dashboard's PED_IDS list -- a business list
 * already validated against production, not to be reordered, retyped or deduped.
 * There are exactly 38.
 *
 * Sent to the dashboard iframe over postMessage so this business data stays out of
 * the publicly served HTML file.
 */
const CELESC_PED_IDS = [
  'EFA00960', 'EFA00970', 'Germania_SuperCenter',
  'Posto_Sao_Marcos', 'Gaboardi_Hotel', 'EFA00990',
  'Posto_Planeta', 'Supermercado_Caita', 'Bonno',
  'EFA01000', 'EFA01010', 'Metropolitan',
  'EFA01020', 'SN20052204030096', 'certi_estacionamento',
  '220420230075', 'FZ2401000037', '220420230047',
  'FZ2401000024', 'saomarcos_teubarao', 'real_nob_orleans',
  'praca_sao_joaquim', 'praca_central_urupema', 'pref_urubici',
  'udesc_lages', 'open_mall_chap_dc', 'open_mall_chap_ac',
  'dois_pinheiros_vid', 'ag5_sta_cecilia', 'agencia_riosul',
  'm7_mafra', 'agencia_chap', '220420230043',
  '220420230039', '220420230055', '220420230061',
  '220420230041', '220420230062',
];

/**
 * Charge boxes that count as P&D, by theme. A theme present here gets the standalone
 * indicators dashboard (public/indicators-dashboard.html, hosted by
 * IndicatorsDashboardFrame); an empty list means the tenant has no project breakdown.
 *
 * NOT enough to onboard another tenant: the HTML still hardcodes CELESC in its
 * <title>, its <h1>, the PDF header and the PDF filename. Enabling a second tenant
 * means sending those over dashboard-config too.
 *
 * HOST RESOLUTION TRAP: a theme present in webSocketApiUrlsDictionary takes
 * precedence over REACT_APP_API_URL *and* REACT_APP_WEBSOCKET_URL, forcing BOTH the
 * API and the websocket to that tenant's PRODUCTION hosts. Running locally with such
 * a theme joins the live production socket. Use a '<tenant>-local' alias instead:
 * absent from that dictionary, both hosts fall back to env, so the API can point at
 * production while the websocket stays elsewhere.
 */
const DASHBOARD_BREAKDOWN_BY_THEME = {
  celesc: CELESC_PED_IDS,
  // Development-only: absent from a production bundle, so no real tenant gets the
  // dashboard by accident.
  ...(process.env.NODE_ENV === 'development'
    ? { 'celesc-local': CELESC_PED_IDS, move: [] }
    : {}),
};

/**
 * The active theme, for every consumer of the two helpers below.
 *
 * useApp writes localStorage 'theme' inside an async .then(), so on the first render
 * after a cold start -- or after localStorage was cleared -- it is still empty. Falls
 * back to the same env var useApp itself falls back to (see useApp.ts).
 *
 * This MUST stay a single function. Reading only localStorage in one consumer and the
 * fallback in another is not a cosmetic split: it renders the dashboard (page-level
 * check passes via env) while getDashboardBreakdownIds(null) returns [], so isPeD() is
 * always false and the whole P&D breakdown silently reports zero -- and it resolves
 * apiBase against the wrong host, because a theme in webSocketApiUrlsDictionary would
 * have overridden REACT_APP_API_URL.
 */
export const resolveTheme = () =>
  localStorage.getItem('theme') || process.env.REACT_APP_THEME || '';

export const hasIndicatorsDashboard = (theme) =>
  Boolean(theme) && theme in DASHBOARD_BREAKDOWN_BY_THEME;

export const getDashboardBreakdownIds = (theme) =>
  DASHBOARD_BREAKDOWN_BY_THEME[theme] || [];
